import { memo } from "react";
import { usePerformanceSnapshot } from "./store";

const value = (input: unknown, suffix = "") => input === undefined || input === null
  ? "Unavailable"
  : `${input}${suffix}`;

export const PerformanceHud = memo(function PerformanceHud() {
  const stats = usePerformanceSnapshot();
  const rows: [string, string][] = [
    ["Backend", stats.backend],
    ["Android runtime", value(stats.androidRuntime)],
    ["Android renderer", value(stats.androidRenderer)],
    ["Sender codec", value(stats.senderCodec || stats.codec)],
    ["Sender encoder", value(stats.senderEncoder)],
    ["Encoder type", value(stats.senderEncoderType)],
    ["Configured FPS", value(stats.configuredFps)],
    ["New captured FPS", value(stats.capturedFps)],
    ["Hardware encoded FPS", value(stats.encodedFps)],
    ["Browser decoder", value(stats.decoderImplementation)],
    ["Hardware decode", stats.powerEfficientDecoder === undefined ? "Unknown" : stats.powerEfficientDecoder ? "Yes" : "No"],
    ["ICE path", value(stats.icePath)],
    ["Resolution", stats.width && stats.height ? `${stats.width} × ${stats.height}` : "Unavailable"],
    ["Decoded FPS", value(stats.fps)],
    ["Dropped frames", value(stats.droppedFramePercent, "%")],
    ["Pi gateway drops", value(stats.streamGatewayDrops)],
    ["Pi stream queue", value(stats.streamQueueDepth, " frame(s)")],
    ["Connection mode", value(stats.connectionMode)],
    ["Average decode", value(stats.averageDecodeTimeMs, " ms")],
    ["Decoder queue", value(stats.decoderQueueSize, " frame(s)")],
    ["Longest frame freeze", value(stats.maxFreezeDurationMs, " ms")],
    ["Frame gaps ≥150 ms", `${value(stats.frameGapCount)} · max ${value(stats.maxFrameGapMs, " ms")}`],
    ["Jitter buffer", value(stats.averageJitterBufferResidenceMs, " ms")],
    ["RTT", value(stats.rttMs, " ms")],
    ["Touch-to-visible", value(stats.touchToVisibleMs, " ms")],
    ["Failure reconnects", value(stats.reconnectCount)],
    ["Data channel", `${value(stats.dataChannelState)} · ${value(stats.dataBufferedAmount, " B queued")}`],
    ["Audio", `${value(stats.audioState)} · ${value(stats.audioCodec)}`],
    ["Audio buffer", value(stats.audioBufferedSeconds, " s")],
    ["Audio received", value(stats.audioBytesReceived, " B")],
    ["Audio reconnects / drops", `${value(stats.audioReconnectCount)} / ${value(stats.audioDroppedBytes, " B")}`],
    ["Audio buffering", `${value(stats.audioBufferingCount)} · max ${value(stats.audioBufferingMaxMs, " ms")}`],
    ["Relay display gaps", `${value(stats.relayDisplayGapCount)} · max ${value(stats.relayDisplayMaxGapMs, " ms")}`],
    ["Relay audio gaps", `${value(stats.relayAudioGapCount)} · max ${value(stats.relayAudioMaxGapMs, " ms")}`],
    ["Relay slow browser sends", `${value(stats.relayDisplaySlowSends)} video / ${value(stats.relayAudioSlowSends)} audio`],
    ["Long tasks", `${stats.longTaskCount} · ${stats.longTaskTotalMs} ms total · ${stats.longTaskMaxMs} ms max`],
    ["Emulator CPU", value(stats.emulatorCpuPercent, "%")],
    ["Gateway CPU", value(stats.gatewayCpuPercent, "%")],
    ["AI CPU", value(stats.aiCpuPercent, "%")],
  ];
  return <details className="performance-hud">
    <summary>Performance HUD <span className={`hud-state state-${stats.connectionState}`}>{stats.connectionState}</span></summary>
    <div>{rows.map(([label, result]) => <div key={label}><span>{label}</span><strong>{result}</strong></div>)}</div>
  </details>;
});
